import { useMemo } from 'react';
import Dropdown from 'components/elements/Dropdown';
import RadioButtons from 'components/elements/RadioButtons';
import { useCompanyLocationFilters } from 'hooks/useCompanyLocationFilters';
import { useAvailableCities } from 'hooks/useUserCityAccess';
import { STATE_CODE_TO_LABEL } from 'utils/constants/location';

const StateFilter = () => {
  const { stateFilter, selectState } = useCompanyLocationFilters();
  const { availableStates } = useAvailableCities();

  const stateOptions = useMemo(
    () =>
      Object.keys(availableStates).map((key) => ({
        value: key,
        label: STATE_CODE_TO_LABEL[key] || key,
      })),
    [availableStates],
  );

  const indicatorText = useMemo(() => {
    if (!stateFilter) {
      return '';
    }

    return STATE_CODE_TO_LABEL[stateFilter]?.toUpperCase() || '';
  }, [stateFilter]);

  return (
    <Dropdown title="State" filterCount={indicatorText}>
      <RadioButtons
        value={stateFilter || ''}
        onChange={selectState}
        options={stateOptions}
      />
    </Dropdown>
  );
};

export default StateFilter;
